import Falvoro from "../assets/projects/Falvoro.png";
import flash from "../assets/projects/flash.png";
import MERN_Stack from "../assets/projects/MERN_BOOK.png";
import Daily from "../assets/projects/Daily_motion.png";
import Ali from "../assets/projects/Aliexpress.png";
import portfolio from "../assets/projects/portfolio.png";
import Shopshy from "../assets/projects/shopshy.png";
import e_commerce from "../assets/projects/Html_ecommerce.png";
import e_schoole from "../assets/projects/E_school.png";
import Aahan from "../assets/projects/aahan.png";
import SurveyDu from "../assets/projects/surveydu.png";
import Polstar from "../assets/projects/polstar.png";
import Presto from "../assets/projects/presto.png";
import MyBankBook from "../assets/projects/mybankbook.png";
import ICA from "../assets/projects/ica.png";
import KFM from "../assets/projects/kfm.png";
import MBBDashboard from "../assets/projects/mbb_dashboard.png";
import JobHunt from "../assets/projects/job_hunt.png";
import PrestoRewards from "../assets/projects/presto_rewards.png";

export const initialData = [
  {
    id: 20,
    name: "Presto Rewards App",
    image: PrestoRewards,
    github: "",
    live: "https://sys.prestorewardsapp.com/login",
    intro:
      "Presto Rewards SaaS App - Corporate customer loyalty, rewards management, and incentive analytics SaaS platform for Presto Plast India featuring secure access, user state validation, and points distribution.",
    technology: "React.js, Redux, Zod, Laravel",
    category: "SaaS App",
  },
  {
    id: 19,
    name: "Job Hunt",
    image: JobHunt,
    github: "",
    live: "https://job-hunt-sandy-delta.vercel.app/",
    intro:
      "Job Hunt is a full-stack job portal web application where job seekers can search and apply for jobs, while recruiters can post job openings and manage applicant submissions.",
    technology: "React.js, Node.js, Express.js, MongoDB, Redux Toolkit, Tailwind CSS",
    category: "Full Stack MERN",
  },
  {
    id: 18,
    name: "My Bank Book SaaS Dashboard",
    image: MBBDashboard,
    github: "",
    live: "https://mbb.timdtech.com/loan-snapshot/",
    intro:
      "My Bank Book SaaS Dashboard - Financial & banking SaaS analytics web app featuring loan summary snapshots, interest validation, bank statement analysis, and compliance calendar built with Next.js, TypeScript, Redux, and Zod.",
    technology: "Next.js, TypeScript, Redux, Zod, Tailwind CSS",
    category: "SaaS App",
  },
  {
    id: 17,
    name: "Kolkata Facility Management",
    image: KFM,
    github: "",
    live: "https://kolkatafacilitymanagement.com/",
    intro:
      "Kolkata Facility Management (Vaishnabi Housekeeping Solution) - Corporate housekeeping, receptionist, security, and facility management services landing page platform built with WordPress & Elementor.",
    technology: "HTML5, CSS3, Bootstrap, WordPress, Elementor",
    category: "Frontend & Web",
  },
  {
    id: 16,
    name: "I & CA Book Store",
    image: ICA,
    github: "",
    live: "https://www.wbicabooks.com/",
    intro:
      "I & CA Book Store - Official online literature and book store portal for the Information & Cultural Affairs Dept, Govt. of West Bengal, built with WordPress and WooCommerce.",
    technology: "HTML5, CSS3, Bootstrap, WordPress, WooCommerce",
    category: "Frontend & Web",
  },
  {
    id: 15,
    name: "My Bank Book",
    image: MyBankBook,
    github: "",
    live: "https://mybankbook.in/",
    intro:
      "My Bank Book - Official website for banking and financial automation solutions showcasing features, pricing, and company services built with a custom WordPress theme.",
    technology: "HTML5, CSS3, Bootstrap, WordPress, Custom Theme",
    category: "Frontend & Web",
  },
  {
    id: 14,
    name: "Presto Plast Group",
    image: Presto,
    github: "",
    live: "https://webs2.prestoplastgroup.com/",
    intro:
      "Corporate manufacturing and industrial site for Presto Plast Group showcasing electrical switchgear, power solutions, and plastic engineering products built with WordPress & Elementor.",
    technology: "HTML5, CSS3, Bootstrap, WordPress, Elementor",
    category: "Frontend & Web",
  },
  {
    id: 13,
    name: "Polstar",
    image: Polstar,
    github: "",
    live: "https://web.polstarfans.com/",
    intro:
      "Polstar Fans - E-commerce brand platform showcasing premium high-speed ceiling, wall, and pedestal fan collections built with WordPress, WooCommerce, and Elementor.",
    technology: "HTML5, CSS3, WordPress, WooCommerce, Elementor",
    category: "Frontend & Web",
  },
  {
    id: 12,
    name: "SurveyDu",
    image: SurveyDu,
    github: "",
    live: "https://www.surveydu.com/",
    intro:
      "Empowering civil & survey engineering professionals with calculation tools, learning resources, live webinars, discussion forums, and industry updates built on a custom WordPress theme.",
    technology: "HTML5, CSS3, Bootstrap, WordPress, Custom Theme",
    category: "Frontend & Web",
  },
  {
    id: 11,
    name: "aahan.world",
    image: Aahan,
    github: "",
    live: "https://aahan.world/",
    intro:
      "Aahan Foundation NGO platform showcasing social impact programs across Rural Education, Clean Water & Sanitation, Women's Empowerment, and Child Food Security built with a custom WordPress theme.",
    technology: "HTML5, CSS3, Bootstrap, WordPress, Custom Theme",
    category: "Frontend & Web",
  },
  {
    id: 1,
    name: "StyleHive",
    image: Ali,
    github: "https://github.com/IM-Partha/StyleHive",
    live: "https://aliexpress-ui.vercel.app/",
    intro:
      "Developed an StyleHive e-commerce platform using ReactJS, Node.js, Express.js, and MongoDB.",
    technology: "React.js, Tailwind, Express.js, MongoDB, Razorpay Node.js",
    category: "Full Stack MERN",
  },
  {
    id: 2,
    name: "shopsy",
    image: Shopshy,
    github: "https://github.com/IM-Partha/shopsy/tree/main",
    live: "https://shopsy-orcin.vercel.app/",
    intro:
      "Developed an online E-commerce platform using ReactJS, Tailwind CSS, AOS, and React Slick.",
    technology: "React.js, Tailwind, Express.js, MongoDB, Node.js",
    category: "Frontend & Web",
  },
  {
    id: 10,
    name: "E_commerce",
    image: e_commerce,
    github: "https://github.com/IM-Partha/Html_e-commerce",
    live: "https://6914c7911846d54cee8196b1--cool-hotteok-392637.netlify.app/",
    intro:
      "Developed a responsive E-commerce website using HTML, CSS, Bootstrap, and JavaScript, with UI/UX design prototypes created in Figma.",
    technology: "HTML5, CSS3, WordPress, Elementor, Figma",
    category: "Frontend & Web",
  },
  {
    id: 3,
    name: "Book Store",
    image: MERN_Stack,
    github: "https://github.com/IM-Partha/Book_store",
    live: "https://book-store-a84v-ui.vercel.app/",
    intro:
      "Developed an online Book Store platform using ReactJS, Tailwind CSS, Node.js, Express.js, and MongoDB.",
    technology: "React.js, Tailwind, Express, Node.js, MongoDB",
    category: "Full Stack MERN",
  },
  {
    id: 4,
    name: "Flashcard-Generator",
    image: flash,
    github: "https://github.com/IM-Partha/Flashcard",
    live: "https://flashcard-lac-nu.vercel.app/",
    intro:
      "Flashcard generator that allows users to Add Something importent notes in group of Cards with the Images.",
    technology: "React.js, Tailwind, JavaScript",
    category: "Frontend & Web",
  },
  {
    id: 5,
    name: "Dailymotion",
    image: Daily,
    github: "https://github.com/IM-Partha/Daily",
    live: "https://dailymotion-six.vercel.app/",
    intro:
      "Built a responsive video streaming platform using ReactJS, Tailwind CSS, firebase.",
    technology: "React.js, Tailwind, Firebase",
    category: "Frontend & Web",
  },
  {
    id: 7,
    name: "Falvoro",
    image: Falvoro,
    github: "https://github.com/IM-Partha/Food-App",
    live: "https://food-app-mu-drab.vercel.app/",
    intro: "Food ordering website built with React, Redux, Tailwind CSS, and Razorpay.",
    technology: "React.js, Redux, Tailwind, JavaScript, Razorpay, Node.js",
    category: "Frontend & Web",
  },
  {
    id: 8,
    name: "Portfolio",
    image: portfolio,
    github: "https://github.com/IM-Partha/new_protfolio",
    live: "https://new-protfolio-taupe.vercel.app/",
    intro:
      "Developed a personal portfolio website using ReactJS and Tailwind CSS for a responsive and modern UI.",
    technology: "React.js, Tailwind, JavaScript, Figma",
    category: "Frontend & Web",
  },
  {
    id: 9,
    name: "E-School",
    image: e_schoole,
    github: "https://github.com/IM-Partha/School_web",
    live: "https://690e3647419437fd38005d60--lovely-sable-91b58f.netlify.app/",
    intro:
      "Developed a responsive E-School website using HTML, CSS, Bootstrap, and JavaScript, with UI/UX design prototypes created in Figma.",
    technology: "HTML5, CSS3, WordPress, Elementor, Figma",
    category: "Frontend & Web",
  },
];

export const getProjectsList = () => {
  const stored = localStorage.getItem("custom_projects");
  if (stored) {
    try {
      let storedProjects = JSON.parse(stored);
      // Ensure removed demo projects are filtered out
      storedProjects = storedProjects.filter((p) => p.id !== 6 && p.intro !== "A Demo E-commerce Project using Redux Toolkit.");
      // Ensure E-Commerce projects and My Bank Book are categorized as Frontend & Web
      storedProjects = storedProjects.map((p) => {
        let item = p;
        if (item.category === "E-Commerce") {
          item = { ...item, category: "Frontend & Web" };
        }
        if (item.id === 15 || item.live === "https://mybankbook.in/") {
          item = {
            ...item,
            category: "Frontend & Web",
            intro: "My Bank Book - Official website for banking and financial automation solutions showcasing features, pricing, and company services built with a custom WordPress theme.",
          };
        }
        return item;
      });
      const missingInitial = initialData.filter(
        (initItem) => !storedProjects.some((p) => p.id === initItem.id || p.name.toLowerCase() === initItem.name.toLowerCase())
      );
      let finalProjects = storedProjects;
      if (missingInitial.length > 0) {
        finalProjects = [...missingInitial, ...storedProjects];
      }
      localStorage.setItem("custom_projects", JSON.stringify(finalProjects));
      return finalProjects;
    } catch (e) {
      return initialData;
    }
  }
  return initialData;
};

export const data = getProjectsList();

